function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// eslint-disable-next-line no-restricted-imports

/**
 * Creates validation props for a Spectrum field. If `isValid` is true, returns
 * empty props. If false, returns  { errorMessage, validationState: 'invalid' }
 * @param isValid Whether props represent valid state
 * @param errorMessage Error message in the case `isValid` is false
 */
export function createValidationProps(isValid, errorMessage) {
  if (isValid) {
    return {};
  }
  return {
    errorMessage,
    validationState: 'invalid'
  };
}

/**
 * Extract DOM node from React Spectrum component ref.
 * @param ref
 */
export function extractSpectrumHTMLElement(ref) {
  var _ref$UNSAFE_getDOMNod;
  return (_ref$UNSAFE_getDOMNod = ref === null || ref === void 0 ? void 0 : ref.UNSAFE_getDOMNode()) !== null && _ref$UNSAFE_getDOMNod !== void 0 ? _ref$UNSAFE_getDOMNod : null;
}

/**
 * Extract lastElementChild from DOM element for given React Spectrum component
 * ref.
 * @param ref
 */
export function extractSpectrumLastChildHTMLElement(ref) {
  var _ref$UNSAFE_getDOMNod2;
  var maybeHTMLElement = ref === null || ref === void 0 || (_ref$UNSAFE_getDOMNod2 = ref.UNSAFE_getDOMNode()) === null || _ref$UNSAFE_getDOMNod2 === void 0 ? void 0 : _ref$UNSAFE_getDOMNod2.lastElementChild;
  return identityExtractHTMLElement(maybeHTMLElement);
}

/**
 * Find the popover associated with a given Spectrum ComboBox ref.
 * @param ref The ref to the Spectrum ComboBox component
 */
export function findSpectrumComboBoxScrollArea(ref) {
  return findSpectrumPopoverScrollArea(ref, 'input');
}

/**
 * Find the popover associated with a given Spectrum Picker ref.
 * @param ref The ref to the Spectrum Picker component
 */
export function findSpectrumPickerScrollArea(ref) {
  return findSpectrumPopoverScrollArea(ref, 'button');
}

/**
 * Find the popover associated with a given Spectrum component ref.
 * @param ref The ref to the Spectrum component
 * @param triggerElementType The type of element that triggers the popover
 */
export function findSpectrumPopoverScrollArea(ref, triggerElementType) {
  var maybeHTMLElement = ref === null || ref === void 0 ? void 0 : ref.UNSAFE_getDOMNode();
  var trigger = maybeHTMLElement === null || maybeHTMLElement === void 0 ? void 0 : maybeHTMLElement.querySelector(triggerElementType);
  var popupId = trigger === null || trigger === void 0 ? void 0 : trigger.getAttribute('aria-controls');
  var scrollArea = popupId == null ? null : document.getElementById(popupId);
  return scrollArea;
}

/**
 * Get the position of a selected item in a list of keyed items. The position is
 * based on the index, item height, and top offset.
 * @param keyedItems The list of keyed items
 * @param itemHeight The height of each item
 * @param selectedKey The key of the selected item
 * @param topOffset The offset from the top of the list (e.g. if there is top
 * padding surrounding the entire list)
 */
export function getPositionOfSelectedItem(_x) {
  return _getPositionOfSelectedItem.apply(this, arguments);
}

/**
 * Returns the given object if it is an HTMLElement. Otherwise returns null.
 * @param maybeHTMLElement
 */
function _getPositionOfSelectedItem() {
  _getPositionOfSelectedItem = _asyncToGenerator(function* (_ref) {
    var keyedItems = _ref.keyedItems,
      itemHeight = _ref.itemHeight,
      selectedKey = _ref.selectedKey,
      topOffset = _ref.topOffset;
    var i = keyedItems.findIndex(item => {
      var _item$item$key, _item$item;
      return ((_item$item$key = (_item$item = item.item) === null || _item$item === void 0 ? void 0 : _item$item.key) !== null && _item$item$key !== void 0 ? _item$item$key : item.key) === selectedKey;
    });
    if (i <= 0) {
      return topOffset;
    }
    return itemHeight * i + topOffset;
  });
  return _getPositionOfSelectedItem.apply(this, arguments);
}
export function identityExtractHTMLElement(maybeHTMLElement) {
  return maybeHTMLElement instanceof HTMLElement ? maybeHTMLElement : null;
}
//# sourceMappingURL=SpectrumUtils.js.map